import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Space, Modal, Form, Input, Checkbox, Tag, message, Popconfirm, Tree } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SafetyOutlined } from '@ant-design/icons';
import { roleApi, menuApi } from '../services/api';

export default function AdminRolesPage() {
  const [roles, setRoles] = useState([]);
  const [allMenuOptions, setAllMenuOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [checkedMenus, setCheckedMenus] = useState([]);
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const [rRes, mRes] = await Promise.all([roleApi.list(), menuApi.listAll()]);
      if (rRes.success) setRoles(rRes.data || []);
      if (mRes.success) setAllMenuOptions(mRes.data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const openModal = (role) => {
    setEditingRole(role);
    setModalOpen(true);
    if (role) {
      let menus = [];
      try { menus = JSON.parse(role.menus || '[]'); } catch {}
      setCheckedMenus(menus);
      form.setFieldsValue({ name: role.name });
    } else {
      setCheckedMenus([]);
      form.resetFields();
    }
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      const data = { name: values.name, menus: checkedMenus };
      let res;
      if (editingRole) res = await roleApi.update(editingRole.id, data);
      else res = await roleApi.create(data);
      if (res.success) {
        message.success(editingRole ? '更新成功' : '创建成功');
        setModalOpen(false);
        form.resetFields();
        loadData();
      } else message.error(res.message);
    } catch (e) { if (e.errorFields) return; message.error('操作失败'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id, name) => {
    if (name === '管理员') { message.error('不能删除管理员角色'); return; }
    const res = await roleApi.delete(id);
    if (res.success) { message.success('已删除'); loadData(); }
    else message.error(res.message);
  };

  const collectMenuNodes = (nodes = []) => {
    let arr = [];
    nodes.forEach(n => {
      arr.push({ key: n.key, title: n.title });
      if (n.children && n.children.length) arr = arr.concat(collectMenuNodes(n.children));
    });
    return arr;
  };
  const allMenuFlat = collectMenuNodes(allMenuOptions);

  const columns = [
    { title: '角色名称', dataIndex: 'name', width: 120 },
    { title: '权限菜单', dataIndex: 'menus', render: (v) => {
      let menus = [];
      try { menus = JSON.parse(v || '[]'); } catch {}
      return <Space size={4} wrap>{menus.map(m => {
        const opt = allMenuFlat.find(o => o.key === m);
        return opt ? <Tag key={m}>{opt.title}</Tag> : null;
      })}</Space>;
    }},
    { title: '操作', width: 120, render: (_, r) => (
      <Space>
        <Button size="small" icon={<EditOutlined />} onClick={() => openModal(r)}>编辑</Button>
        <Popconfirm title="确认删除？" onConfirm={() => handleDelete(r.id, r.name)}>
          <Button size="small" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      </Space>
    )},
  ];

  return (
    <div>
      <Card size="small" title={<Space><SafetyOutlined /> 角色管理</Space>}
        extra={<Button type="primary" icon={<PlusOutlined />} onClick={() => openModal(null)}>新建角色</Button>}>
        <Table dataSource={roles} columns={columns} rowKey="id" size="small" loading={loading} pagination={false} />
      </Card>

      <Modal title={editingRole ? '编辑角色' : '新建角色'} open={modalOpen} onOk={handleSave}
        onCancel={() => { setModalOpen(false); form.resetFields(); }} confirmLoading={saving}
        okText="确认" cancelText="取消" destroyOnClose width={500}>
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="角色名称" rules={[{ required: true, message: '请输入角色名称' }]}>
            <Input placeholder="输入角色名称" />
          </Form.Item>
          <Form.Item label="权限菜单">
            <Tree
              checkable
              defaultExpandAll
              treeData={allMenuOptions}
              checkedKeys={checkedMenus}
              onCheck={(keys) => setCheckedMenus(Array.isArray(keys) ? keys : keys.checked)}
              height={320}
              style={{ border: '1px solid #f0f0f0', borderRadius: 6, padding: 8, overflow: 'auto' }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
